/*
 * Vehicle validation related services
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2026 Gallagher Bassett Services, Inc.
 */

import { Injectable } from '@angular/core';
import { Constants } from 'app/shared/config/constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface VehicleValidationResponse {
  valid: boolean;
}

@Injectable ( {
  providedIn: 'root'
} )
export class VehicleValidationService {
  readonly url = Constants.vehicleValidationUrl;

  constructor( private http: HttpClient ) {
  }

  validate( ssClaimNumber: string ): Observable<VehicleValidationResponse> {
    const params = new HttpParams ().set ( 'ssClaimNumber', ssClaimNumber );
    return this.http.post<VehicleValidationResponse> ( this.url, null, { params } );
  }
}

